import { render, staticRenderFns } from "./Npm.vue?vue&type=template&id=bd3998a6&"
import script from "./Npm.vue?vue&type=script&lang=js&"
export * from "./Npm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports